import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const AglomeracionDatosPrincipaisSection = ({aglomeracion}) => {
    return (
        <SectionCard title="Datos principais">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField label="Código:" value={aglomeracion.stats.codigo} />
                    <SectionField label="Nome:" value={aglomeracion.stats.nome} />
                    <SectionField
                        label="EDAR:"
                        value={aglomeracion.stats.nomeedar}
                        linkPath={`/aglomeracions/${aglomeracion.id}/edars/${aglomeracion.stats.idedar}/summary`}
                        tooltipText="EDAR da aglomeración"
                    />
                    <SectionField
                        label="Tratamento:"
                        value={aglomeracion.stats.tipotratamento}
                        tooltipText="Nivel de tratamento"
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    {/*
                    <SectionField
                        label="Nome EDAR:"
                        value={aglomeracion.stats.nomeedar}
                        linkPath={`/aglomeracions/${aglomeracion.id}/edars/${aglomeracion.stats.idedar}/summary`}
                        tooltipText="EDAR da aglomeración"
                    />
                    */}
                    
                    <SectionField
                        label="Ente público representativo:"
                        value={aglomeracion.ente_publico_representativo_label}
                        tooltipText="Administración pública considerada como Ente público representativo da aglomeración
                            dacordo dacordo os termos establecidos na LEI 1/2022, do 12 de xullo, de mellora da xestión
                            do ciclo integral da auga"
                    />
                    <SectionField
                        label="A.P.R.S.:"
                        value={aglomeracion.administracion_publica_responsable_label}
                        tooltipText="Administración(s) pública(s) responsable(s) do servizo. Administracións públicas que teñen a
                            competencia para prestar os distintos servizos vinculados ao ciclo integral da auga, na
                            aglomeración, consonte o disposto na Lei 7/1985, do 2 de abril, reguladora das bases do
                            réxime local, nos termos establecidos na lexislación estatal e autonómica"
                    />
                    <SectionField
                        label="Titulares infraestruturas:"
                        value={aglomeracion.titulares_infraestruturas_label}
                        tooltipText="Administración(s) pública(s) que son titulares de infraestruturas da aglomeración dacordo os
                            termos establecidos na LEI 1/2022, do 12 de xullo, de mellora da xestión do ciclo integral da
                            auga"
                    />
                    <SectionField
                        label="S.A.I.:"
                        value={aglomeracion.sai}
                        unit="%"
                        tooltipText="Porcentaxe sobre a poboación total da aglomeración con Saneamento autónomo individual"
                    />

                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default AglomeracionDatosPrincipaisSection;
